@if (authService.hasPermission(Permission.NotificationsRead)) {
<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  matBadgeColor="warn"
  matBadgePosition="before"
  [matBadge]="unRead"
  [matBadgeHidden]="totalUnRead == 0"
  class="notification-btn"
  >
  <mat-icon> notifications </mat-icon>
</button>
<mat-menu
  #menu="matMenu"
  yPosition="above"
  xPosition="after"
  class="notification-menu"
  >
  <div class="notification-content">
    <div class="notification-content__head" (click)="onPrevent($event)">
      <div class="notification-content__label">Notifications</div>
      <div>
        Only show unread
        <mat-slide-toggle
          [(ngModel)]="isUnRead"
          class="notification-content__unread-filter"
          (click)="onUnReadFilter($event)"
        ></mat-slide-toggle>
      </div>
    </div>

    <div class="notification-content__sub" (click)="onPrevent($event)">
      <div>
        @if (authService.hasPermission(Permission.NotificationsFull)) {
          <mat-select
            [(ngModel)]="category"
            placeholder="Category"
            class="notification-content__category"
            (click)="onCategoryClick($event)"
            (selectionChange)="onCategoryFilter()"
            >
            @for (category of categoryList; track category) {
              <mat-option
                [value]="category.value"
                >
                {{ category.label }}
              </mat-option>
            }
          </mat-select>
        }
      </div>
      <div>
        <button
          mat-button
          class="notification-content__mark-as-read"
          (click)="onMarkAsRead($event)"
          >
          Mark as read
        </button>
      </div>
    </div>

    <div class="notification-list" (scroll)="onScroll($event)">
      @for (notification of showingData; track notification) {
        <a
          class="notification-item"
          (click)="onNotificationClick(notification)"
          >
          <div class="flex-row">
            <mat-icon
              class="menu-icon notification-item__icon"
              [ngClass]="[notification.iconColor]"
              >{{ notification.icon }}</mat-icon
              >
              <div class="notification-item__label">
                {{ labelMapping[notification.type] }}
              </div>
              <div class="spacer"></div>
              @if (notification.state === 'Unread') {
                <div
                  class="notification-item__status"
                ></div>
              }
            </div>
            <div class="notification-item__content">{{ notification.content }}</div>
            <div
              class="notification-item__time"
          matTooltip="{{
            notification.createdAt | dateAgo : currentConfigDate : true | async
          }}"
              >
              {{ notification.createdAt | dateAgo : currentConfigDate | async }}
            </div>
          </a>
        }
        @if (isLoading) {
          <div class="loading-overlay">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        }
      </div>
    </div>
  </mat-menu>
}
